/**
 * Legacy-compatible product filters for older browsers (Tizen 2014, etc.)
 * This file uses ES5 syntax only.
 */
(function() {
  'use strict';

  // Simple debounce function (no lodash dependency)
  function debounce(func, wait, options) {
    var timeout, lastArgs, lastThis, result, lastCallTime;
    var maxWait = options && options.maxWait ? options.maxWait : null;
    var lastInvokeTime = 0;

    function invokeFunc(time) {
      var args = lastArgs;
      var thisArg = lastThis;
      lastArgs = lastThis = undefined;
      lastInvokeTime = time;
      result = func.apply(thisArg, args);
      return result;
    }

    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime;
      var timeSinceLastInvoke = time - lastInvokeTime;
      return (lastCallTime === undefined) ||
        (timeSinceLastCall >= wait) ||
        (timeSinceLastCall < 0) ||
        (maxWait !== null && timeSinceLastInvoke >= maxWait);
    }

    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime;
      var timeSinceLastInvoke = time - lastInvokeTime;
      var timeWaiting = wait - timeSinceLastCall;
      return maxWait !== null
        ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke)
        : timeWaiting;
    }

    function timerExpired() {
      var time = Date.now();
      if (shouldInvoke(time)) {
        return trailingEdge(time);
      }
      timeout = setTimeout(timerExpired, remainingWait(time));
    }

    function trailingEdge(time) {
      timeout = undefined;
      if (lastArgs) {
        return invokeFunc(time);
      }
      lastArgs = lastThis = undefined;
      return result;
    }

    function debounced() {
      var time = Date.now();
      var isInvoking = shouldInvoke(time);
      lastArgs = arguments;
      lastThis = this;
      lastCallTime = time;

      if (isInvoking) {
        if (timeout === undefined) {
          lastInvokeTime = time;
          timeout = setTimeout(timerExpired, wait);
          return result;
        }
        if (maxWait !== null) {
          timeout = setTimeout(timerExpired, wait);
          return invokeFunc(time);
        }
      }
      if (timeout === undefined) {
        timeout = setTimeout(timerExpired, wait);
      }
      return result;
    }

    debounced.cancel = function() {
      if (timeout !== undefined) {
        clearTimeout(timeout);
      }
      lastInvokeTime = 0;
      lastArgs = lastCallTime = lastThis = timeout = undefined;
    };

    return debounced;
  }

  function initializeBlock(block) {
		console.log('js running');

    var togglefiltersButtonLink = document.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__toggle-filters-button-link');
    var formCheckInputs = block.querySelectorAll('.wp-block-byggma-brann-og-lyd-product-filters__form-check-input');
    var formWrapperElement = block.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__form-wrapper');
    var formElement = block.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__form');
    var productContainer = document.getElementById('product-filters-products-container');
    var currentXHR = null;

    // Serialize form data to URL-encoded string
    function serializeForm(form) {
      if (!form || !form.elements) {
        return '';
      }

      var parts = [];
      var elements = form.elements;
      var i, element, name, value;

      for (i = 0; i < elements.length; i++) {
        element = elements[i];
        name = element.name;
        value = element.value;

        if (!name) continue;
        if (element.disabled) continue;
        if (element.type === 'checkbox' && !element.checked) continue;
        if (element.type === 'radio' && !element.checked) continue;

        parts.push(encodeURIComponent(name) + '=' + encodeURIComponent(value));
      }

      return parts.join('&');
    }

    // Parse HTML string and extract element by ID
    function parseHTMLAndGetById(htmlString, id) {
      var tempDiv = document.createElement('div');
      // Wrap in a container to handle full HTML documents
      tempDiv.innerHTML = htmlString;
      return tempDiv.querySelector('#' + id);
    }

    // Main function to reload products via AJAX
    function reloadProductsWithUrl(url, shouldScrollContainerIntoView) {
      if (!productContainer) {
        return;
      }

      // Add loading class
      if (productContainer.className.indexOf('is-loading') === -1) {
        productContainer.className = productContainer.className + ' is-loading';
      }

      // Cancel previous request if still pending
      if (currentXHR && currentXHR.readyState !== 4) {
        currentXHR.abort();
      }

      currentXHR = new XMLHttpRequest();

      currentXHR.onreadystatechange = function() {
        if (currentXHR.readyState !== 4) {
          return;
        }

        if (currentXHR.status === 200) {
          var responseText = currentXHR.responseText;
          var wpBlockQueryHtml = parseHTMLAndGetById(responseText, 'product-filters-products-container');

          if (wpBlockQueryHtml) {
            productContainer.innerHTML = wpBlockQueryHtml.innerHTML;

            // Update filter counts from response
            updateFilterCounts(responseText);

            // Scroll into view if needed
            if (shouldScrollContainerIntoView) {
              var rect = productContainer.getBoundingClientRect();
              if (rect.top < 0) {
                try {
                  productContainer.scrollIntoView({ behavior: 'smooth' });
                } catch (e) {
                  // Fallback for browsers that don't support smooth scrolling
                  productContainer.scrollIntoView();
                }
              }
            }
          }
        } else if (currentXHR.status !== 0) {
          // Status 0 means aborted, don't log error for that
          console.error('Request failed with status: ' + currentXHR.status);
        }

        // Remove loading class
        productContainer.className = productContainer.className.replace(/\s*is-loading\s*/g, ' ').trim();

        // Update browser URL without page reload
        if (window.history && window.history.replaceState) {
          try {
            window.history.replaceState({}, '', url);
          } catch (e) {
            // Some browsers may block this, ignore
          }
        }
      };

      currentXHR.open('GET', url, true);
      currentXHR.send();
    }

    // Update filter counts from response HTML
    function updateFilterCounts(responseText) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = responseText;

      var responseLabels = tempDiv.querySelectorAll('label.wp-block-byggma-brann-og-lyd-product-filters__label');
      var i, labelElement, htmlFor, docCountEl, countElement, count;

      for (i = 0; i < responseLabels.length; i++) {
        labelElement = responseLabels[i];
        htmlFor = labelElement.getAttribute('for');

        if (!htmlFor) {
          continue;
        }

        docCountEl = document.querySelector(
          'label.wp-block-byggma-brann-og-lyd-product-filters__label[for="' + htmlFor + '"] .wp-block-byggma-brann-og-lyd-product-filters__count'
        );

        if (!docCountEl) {
          continue;
        }

        countElement = labelElement.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__count');
        count = countElement ? countElement.innerHTML : '';
        docCountEl.innerHTML = count;
      }
    }

    // Set up ResizeObserver or fallback for sub-lists
    function setupSubListHeightTracking() {
      var subListWrappers = document.querySelectorAll(
        '.wp-block-byggma-brann-og-lyd-product-filters__list-wrapper .wp-block-byggma-brann-og-lyd-product-filters__list-wrapper'
      );

      var i;
      for (i = 0; i < subListWrappers.length; i++) {
        (function(subListWrapperElement) {
          var subListElement = subListWrapperElement.querySelector('.wp-block-byggma-brann-og-lyd-product-filters__list');

          var updateHeight = function() {
            if (subListWrapperElement && subListElement && subListElement.offsetHeight) {
              subListWrapperElement.style.cssText =
                subListWrapperElement.style.cssText + '; --sub-list-height: ' + subListElement.offsetHeight + 'px';
            }
          };

          if (subListElement) {
            if (typeof ResizeObserver !== 'undefined') {
              new ResizeObserver(updateHeight).observe(subListElement);
            } else {
              // Fallback: update on window resize and initially
              window.addEventListener('resize', updateHeight);
              updateHeight();
              // Also update after a short delay to catch late renders
              setTimeout(updateHeight, 100);
              setTimeout(updateHeight, 500);
            }
          }
        })(subListWrappers[i]);
      }
    }

    // Set up form height tracking
    function setupFormHeightTracking() {
      var updateFormHeight = function() {
        if (formWrapperElement && formElement && formElement.offsetHeight) {
          formWrapperElement.style.cssText =
            formWrapperElement.style.cssText + '; --filter-form-height: ' + formElement.offsetHeight + 'px';
        }
      };

      if (formElement) {
        if (typeof ResizeObserver !== 'undefined') {
          new ResizeObserver(updateFormHeight).observe(formElement);
        } else {
          window.addEventListener('resize', updateFormHeight);
          updateFormHeight();
          setTimeout(updateFormHeight, 100);
          setTimeout(updateFormHeight, 500);
        }
      }
    }

    // Handle click events using event delegation
    function setupClickHandlers() {
      document.body.addEventListener('click', function(event) {
        var target = event.target || event.srcElement;

        // Handle filter toggle button
        if (togglefiltersButtonLink) {
          var isToggleButton = false;

          if (target.className && target.className.indexOf('wp-block-byggma-brann-og-lyd-product-filters__toggle-filters-button') !== -1) {
            isToggleButton = true;
          } else if (togglefiltersButtonLink.contains && togglefiltersButtonLink.contains(target)) {
            isToggleButton = true;
          }

          if (isToggleButton) {
            if (event.preventDefault) {
              event.preventDefault();
            } else {
              event.returnValue = false;
            }

            var isOpen = togglefiltersButtonLink.className.indexOf('open') !== -1;

            if (isOpen) {
              togglefiltersButtonLink.className = togglefiltersButtonLink.className.replace(/\s*open\s*/g, ' ').trim();
              if (formElement) {
                formElement.className = formElement.className.replace(/\s*open\s*/g, ' ').trim();
              }
              if (formWrapperElement) {
                formWrapperElement.className = formWrapperElement.className.replace(/\s*open\s*/g, ' ').trim();
              }
            } else {
              togglefiltersButtonLink.className = togglefiltersButtonLink.className + ' open';
              if (formElement) {
                formElement.className = formElement.className + ' open';
              }
              if (formWrapperElement) {
                formWrapperElement.className = formWrapperElement.className + ' open';
              }
            }

            return;
          }
        }

        // Handle pagination clicks
        var href = target.href || (target.getAttribute && target.getAttribute('href'));

        if (!href) {
          return;
        }

        if (!productContainer) {
          return;
        }

        if (productContainer.contains && !productContainer.contains(target)) {
          return;
        }

        var targetClass = target.className || '';
        var isPaginationLink =
          targetClass.indexOf('page-numbers') !== -1 ||
          targetClass.indexOf('wp-block-query-pagination-next') !== -1 ||
          targetClass.indexOf('wp-block-query-pagination-previous') !== -1;

        if (!isPaginationLink) {
          return;
        }

        if (event.preventDefault) {
          event.preventDefault();
        } else {
          event.returnValue = false;
        }

        reloadProductsWithUrl(href, true);
      });
    }

    // Deselect child checkboxes when parent is unchecked
    function maybeDeselectChildren(input) {
      if (input.checked) {
        return;
      }

      var nextSibling = input.nextElementSibling || input.nextSibling;
      while (nextSibling && nextSibling.nodeType !== 1) {
        nextSibling = nextSibling.nextSibling;
      }

      if (!nextSibling) return;

      var nextNextSibling = nextSibling.nextElementSibling || nextSibling.nextSibling;
      while (nextNextSibling && nextNextSibling.nodeType !== 1) {
        nextNextSibling = nextNextSibling.nextSibling;
      }

      if (!nextNextSibling) return;

      var formSubCheckInputs = nextNextSibling.querySelectorAll(
        '.wp-block-byggma-brann-og-lyd-product-filters__form-check-input'
      );

      if (!formSubCheckInputs || formSubCheckInputs.length === 0) {
        return;
      }

      var i;
      for (i = 0; i < formSubCheckInputs.length; i++) {
        formSubCheckInputs[i].checked = false;
      }
    }

    // Show/hide elements based on checkbox state
    function evaluateSelectorShow(input) {
      var selectorShow = input.getAttribute('data-selector-show');

      if (!selectorShow) {
        return;
      }

      var elementsToShowOrHide = block.querySelectorAll(selectorShow);
      var i, j, element, formSubCheckInputs;

      for (i = 0; i < elementsToShowOrHide.length; i++) {
        element = elementsToShowOrHide[i];
        element.style.display = input.checked ? 'block' : 'none';

        if (!input.checked) {
          formSubCheckInputs = element.querySelectorAll(
            '.wp-block-byggma-brann-og-lyd-product-filters__form-check-input'
          );

          if (formSubCheckInputs && formSubCheckInputs.length > 0) {
            for (j = 0; j < formSubCheckInputs.length; j++) {
              formSubCheckInputs[j].checked = false;
            }
          }
        }
      }
    }

    // Reload products based on current form state
    function reloadProducts() {
      if (!formElement) {
        return;
      }

      var data = serializeForm(formElement);
      var formElementAction = formElement.action || '';
      formElementAction = formElementAction.replace(/\/$/g, '') + '/';
      var url = data.length > 0 ? formElementAction + '?' + data : formElementAction;

      reloadProductsWithUrl(url, false);
    }

    var debouncedReloadProducts = debounce(reloadProducts, 350, { maxWait: 3000 });

    // Handle checkbox change events
    function onChange(event) {
      event = event || window.event;
      var input = event.target || event.srcElement;

      if (!input) {
        return;
      }

      maybeDeselectChildren(input);
      evaluateSelectorShow(input);

      // Cancel any pending XHR
      if (currentXHR && currentXHR.readyState !== 4) {
        currentXHR.abort();
        currentXHR = null;
      }

      debouncedReloadProducts();
    }

    // Attach change listeners to all filter checkboxes
    function setupChangeHandlers() {
      var i;
      for (i = 0; i < formCheckInputs.length; i++) {
        if (formCheckInputs[i].addEventListener) {
          formCheckInputs[i].addEventListener('change', onChange);
        } else if (formCheckInputs[i].attachEvent) {
          formCheckInputs[i].attachEvent('onchange', onChange);
        }
      }
    }

    // Initialize selector show/hide states
    function initializeSelectorStates() {
      var i;
      for (i = 0; i < formCheckInputs.length; i++) {
        evaluateSelectorShow(formCheckInputs[i]);
      }
    }

    // Run all setup functions
    setupSubListHeightTracking();
    setupFormHeightTracking();
    setupClickHandlers();
    setupChangeHandlers();
    initializeSelectorStates();
  }

  // Initialize when DOM is ready
  function onDOMReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fn, 1);
    } else if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', fn);
    } else if (document.attachEvent) {
      document.attachEvent('onreadystatechange', function() {
        if (document.readyState === 'complete') {
          fn();
        }
      });
    }
  }

  onDOMReady(function() {
    var blocks = document.querySelectorAll('.wp-block-byggma-brann-og-lyd-product-filters');
    var i;

    if (!blocks || blocks.length === 0) {
      return;
    }

    for (i = 0; i < blocks.length; i++) {
      initializeBlock(blocks[i]);
    }
  });

})();
